import { Card, Image, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import { useBnsGuiGeListQuery } from '../store/BnsKeJiApi'

function SoftBuy(props) {
    const [list, setList] = useState([])
    const { data, isSuccess } = useBnsGuiGeListQuery(
        {
            bsg_bg_id: props.bsg_bg_id,
            bsg_bgn_id: props.bsg_bgn_id,
        },
        { refetchOnMountOrArgChange: 1 }
    )
    useEffect(() => {
        if (isSuccess) {
            if (data.Status === 'success') {
                const newArr = data.Result.map((item) => {
                    const {
                        bsg_id: key,
                        bsg_name,
                        bsg_ctime,
                        bsg_cname,
                        bsg_price,
                        bsg_dept_id,
                        bsg_dept_name,
                        bsg_state,
                        bsg_luyou,
                        bsg_image,
                        bsg_goods,
                        bsg_bg_name,
                        bg_id,
                        bsg_bgn_name,
                    } = item
                    return {
                        ...item,
                        key,
                        bsg_name,
                        bsg_ctime,
                        bsg_cname,
                        bsg_price,
                        bsg_dept_id,
                        bsg_dept_name,
                        bsg_state,
                        bsg_luyou,
                        bsg_image,
                        bsg_goods,
                        bsg_bg_name,
                        bg_id,
                        bsg_bgn_name,
                    }
                })
                const sortArr = newArr.sort((a, b) => {
                    const aTime = new Date(a.bsg_ctime).getTime()
                    const bTime = new Date(b.bsg_ctime).getTime()
                    return bTime - aTime
                })
                setList(sortArr)
            } else {
                setList([])
            }
        }
    }, [data, isSuccess])
    return (
        <div style={{ fontSize: 15, padding: '8px 4px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {list.map((item) => (
                    <Card key={item.key} style={{ width: '100%', boxShadow: '1px 1px 3px 0px rgba(0, 0, 0, 0.35)' }}>
                        <Space direction="vertical" align="center" style={{ width: '100%' }}>
                            <Image src={`/api/assets/images/application/${item.bsg_image}`} width="100%" style={{ maxWidth: 320 }} />
                            <div>{item.bsg_name}</div>
                            <div>{item.bsg_price}</div>
                        </Space>
                    </Card>
                ))}
            </div>
            <div style={{ textAlign: 'center', marginTop: 24 }}>
                <Space direction="vertical" size={24} style={{ width: '100%' }}>
                    <Space
                        direction="vertical"
                        align="center"
                        onClick={() => {
                            window.open('https://item.taobao.com/item.htm?ft=t&id=811175053812&spm=a21dvs.23580594.0.0.4fee2c1bp6YAJ7')
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        <img src="./img/home/taobao.gif" alt="" style={{ maxWidth: '100%' }} />
                        <div style={{ marginTop: 8 }}>官方秒发 - 支付宝支付</div>
                    </Space>
                    <Space
                        direction="vertical"
                        align="center"
                        onClick={() => {
                            window.open(
                                'https://item.jd.com/10140492235288.html?sdx=ehi-lLxFuZiE6JnJZYNYhcQiszWTAAMrsmpFuaZDZNqJPe_RLJle5XjsrUnrXmOY'
                            )
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        <img src="./img/home/jingdong.gif" alt="" style={{ maxWidth: '100%' }} />
                        <div style={{ marginTop: 8 }}>企业采购 - 可开发票！</div>
                    </Space>
                </Space>
            </div>
        </div>
    )
}

export default SoftBuy
